import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material';
import { DialogComponent } from '@shared/components/dialog/dialog.component';
import { DialogObjectComponent } from '@shared/components/dialog/template/dialog-json-buider/dialog-object/dialog-object.component';

export interface ObjectJSONBuider {
  root?: any,
  data?: any,
  name?: string,
  index?: string | number
}
interface ConfigHeader {
  hidden: boolean;
  disableSettingButton: boolean;
  disableDeleteButton: boolean;
  disableOpenButton: boolean;
}

interface Breadcrumb {
  root?: string
  whereThis?: Array<any>
}

@Component({
  selector: 'json-template-object',
  templateUrl: './template-object.component.html',
  styleUrls: ['./template-object.component.scss']
})

export class TemplateObjectComponent implements OnInit {
  @Input() isSource = false;
  @Input() isJsonBuilderRoot = false;
  @Input() data;
  @Input() name;
  @Input() index;
  @Input() isOpen = false;
  @Input() breadcrumb: Breadcrumb;
  @Input() configHeader: ConfigHeader = {
    hidden: false,
    disableSettingButton: false,
    disableDeleteButton: false,
    disableOpenButton: false
  };
  @Output() deleteEvent = new EventEmitter<any>();
  @Output() deleteAllEvent = new EventEmitter<any>();

  public object: ObjectJSONBuider = {};
  public nextBreadcrumb: Breadcrumb = {};

  constructor(private dialog: MatDialog) { }

  ngOnInit() {
    Object.assign(this.object, {
      root: this.data,
      data: this.isSource ? this.data : this.data[this.index],
      name: this.name,
      index: this.index
    });
    this.nextBreadcrumb = JSON.parse(JSON.stringify(this.breadcrumb));
    if (!this.isJsonBuilderRoot) {
      this.nextBreadcrumb.whereThis.push({ title: this.object.name ?? 'Objeto' })
    }
  }

  open() {
    this.isOpen = !this.isOpen;
  }

  openDialog() {
    this.dialog.open(DialogComponent, {
      width: '1080px',
      minHeight: '600px',
      disableClose: true,
      data: {
        titleDialog: 'Objeto',
        titleButton: 'Salvar',
        component: DialogObjectComponent,
        contentDialogClassName: 'dialog-content',
        data: this.object,
        breadcrumb: JSON.parse(JSON.stringify(this.breadcrumb))
      },
      autoFocus: false
    })
  }

  onDelete() {
    this.deleteEvent.emit({ index: this.index });
  }

  delete(data) {
    delete this.object.data[data.index];
    if (!Object.keys(this.object.data).length) {
      this.isOpen = false;
      this.deleteAllEvent.emit({ index: this.object.index });
    }
  }
}
